import { field, relation } from '@nozbe/watermelondb/decorators';
import { GROUP_CUSTOMER_SCHEMA } from '../schema';
import { Model } from '@nozbe/watermelondb';

export default class GROUPCUSTOMERS extends Model {
    static table = GROUP_CUSTOMER_SCHEMA;

    static associations = {
        customer: { type: 'belongs_to', key: 'customer_id' },
        groups: { type: 'belongs_to', key: 'group_id' },
    }

    @field('total_outstanding_payment') total_outstanding_payment;

    @relation('customer', 'customer_id') customer;
    @relation('groups', 'group_id') groups;
};